import React, { useState } from 'react'
import FileStructure from '../Components/FileStructure'
import styled from 'styled-components'
import { motion } from 'framer-motion'
import { BiHomeAlt } from "react-icons/bi";
import { TbPhone } from "react-icons/tb";
import { FiMail } from "react-icons/fi";
import axios from 'axios'
import { Link } from 'react-router-dom';
import HamBurg from '../Extra/HamBurg';

const ContactForm = () => {

    const [name, setName] = useState("")
    const [phone, setPhone] = useState("")
    const [mail, setMail] = useState("")
    const [sub, setSub] = useState("")
    const [msg, setMsg] = useState("")

    const handleMessage = async (e) => {
        e.preventDefault();
        try {
            const {data} = await axios.post(`${process.env.REACT_APP_API}/contact/message`, { name, phone, mail, sub, msg })
            console.log(data)

            if (data?.success) {
                setName("")
                setPhone("")
                setMail("")
                setSub("")
                setMsg("")
            }
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <FileStructure>
            <HamBurg />

            <ContactDiv>
                <div className="contactDiv">

                    <ContactHead
                        initial={{ scale: 0, opacity: 0 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{
                            ease: [0.65, 0, 0.35, 1],
                            duration: 1,
                            delay: 1
                        }}
                        className="contactHead">
                        <h3 className='heading'> Your portal  </h3>
                        <h3 className='heading'> to connect </h3>

                        <ContactFormDiv>

                            <form>
                                <div className="formContent">
                                    <label htmlFor="name"> Your name? </label>
                                    <input type="text" id='name' placeholder='Gagan*' autocomplete="off" value={name} onChange={(e) => setName(e.target.value)} required />
                                </div>

                                <div className="formContent">
                                    <label htmlFor="name"> Your contact number? </label>
                                    <input type="text" id='number' placeholder='123456...' autocomplete="off" value={phone} onChange={(e) => setPhone(e.target.value)} required />
                                </div>

                                <div className="formContent">
                                    <label htmlFor="name"> Your mail address? </label>
                                    <input type="text" id='email' placeholder='gagan@gmail.com*' autocomplete="off" value={mail} onChange={(e) => setMail(e.target.value)} required />
                                </div>

                                <div className="formContent">
                                    <label htmlFor="name"> Service you are looking for? </label>
                                    <input type="text" id='name' placeholder='Web Development,Design*' autocomplete="off" value={sub} onChange={(e) => setSub(e.target.value)} required />
                                </div>

                                <div className="formContent">

                                    <label htmlFor="name"> Your message? </label>
                                    <textarea type="text" id='name' placeholder='Hey, Can you help me...' autocomplete="off" value={msg} onChange={(e) => setMsg(e.target.value)} required />
                                </div>

                                <BtnDIv>
                                    <div className="line"></div>
                                    <button type='submit' onClick={e => handleMessage(e)}> Send It~~  </button>
                                </BtnDIv>
                            </form>

                        </ContactFormDiv>
                    </ContactHead>

                    <ContactInfo
                        initial={{ scale: 0, opacity: 0 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{
                            ease: [0.65, 0, 0.35, 1],
                            duration: 1,
                            delay: 1
                        }}
                        className="contactInfo">
                        <div className="infoImg">
                            <img src="/My/me.jpg" alt="" />
                        </div>

                        <ContactDetail>

                            <h3> Mine Details </h3>

                            <div className="details">

                                <Link to={`mailto:gagan270903@gmail.com`} >
                                    <FiMail />
                                    <span> gagan270903@gmail.com </span>
                                </Link>
                            </div>

                            <div className="details">

                                <Link to={`tel:+91 9026705339`} >
                                    <TbPhone />
                                    <span> +91 9026705339 </span>
                                </Link>
                            </div>

                            <div className="details">

                                <Link>
                                    <BiHomeAlt />
                                    <span> Hansari,Jhansi(U.P.),India </span>
                                </Link>
                            </div>

                        </ContactDetail>

                        <ContactDetail>
                            <h3> Social </h3>

                            <div className="details">
                                <Link to={"https://discordapp.com/users/759284811239784468"} target='_blank' > Discord </Link>
                            </div>
                            <div className="details">
                                <Link to={"https://www.linkedin.com/in/gagan-deep-singh-666158238"} target='_blank'> Linkedin </Link>
                            </div>
                            <div className="details">
                                <Link to={"https://github.com/Gagan-deepp"} target='_blank'> Github </Link>
                            </div>
                        </ContactDetail>
                    </ContactInfo>

                </div>
            </ContactDiv>
        </FileStructure>
    )
}

export default ContactForm

const BtnDIv = styled.div`

    position:relative;
    border: none !important;
    margin-top: 5rem;
    .line{
        padding: 0 !important;
        border: none !important;
        height: 1px;
        width: 100%;
        background: var(--white3);
    }

    button{
        background: var(--white2);
        color: var(--blackLight);
        outline: none;
        border: 1px solid white;
        border-radius: 2rem;
        padding: 2rem 1rem;
        width: 10rem;
        height: 10rem;
        text-align: center;
        border-radius: 50%;
        font-size: 1.5rem;
        position : absolute !important;
        top: 0;
        cursor: pointer;
        font-weight: 600;
        right: 0;
        z-index: 1;
        transform: translate(-50% , -50%);
        
        @media only screen and (max-width: 845px) {
            width: 6rem !important;
            height: 6rem !important;
            padding: 1rem !important;
            font-size: 1rem !important;
            font-weight: 700 !important;
        }
    }
`

const ContactDetail = styled.div`

    display: flex;
    flex-direction: column;
    gap: 1rem;

    h3{
        opacity: 0.3;
        text-transform: uppercase;
        font-size: 0.75rem;
        letter-spacing: 2px;
        transition: all 150ms ease-in-out;
        cursor: pointer;

        &:hover{
            opacity: 0.75;
        }
    }

    .details{
        display: flex;
        flex-direction: column;
        gap: 0.75rem;
        
        a{
            display: flex;
            gap: 0.5rem;
            align-items:center;

            span{
                font-size: 0.9rem;
                font-weight: 500;
                letter-spacing: 1px;
            }
        }
    }
`

const ContactInfo = styled(motion.div)`
    flex: 0.3;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 3rem;
    
    @media only screen and (max-width: 845px) {
        flex: 0.2 !important;
    }

    .infoImg{
        width: 5rem;
        height: 5rem;

        img{
            height: 100%;
            width: 100%;
            object-fit: cover;
            border-radius: 50%;
        }
    }
`

const ContactFormDiv = styled.div`
    form{

        display: flex;
        flex-direction: column;
        gap: 2rem;
        padding: 2rem 1rem;

        div{
            border-top:1px solid rgba(255, 255, 255, 0.2);
            padding: 1rem;
            display: flex;
            flex-direction: column;
            gap: 1rem;

            label{
                padding: 1rem 0 0;
                font-size: 1.25rem;
                font-weight: 600;
            }

            textarea{
                height: 7rem;
                resize: none;
            }
            
            input ,textarea {
                background: none;
                outline: none;
                font-size: 1.25rem;
                border: none;
                font-family: var(--font3);
                color: var(--white4);
                font-weight: 600;
                padding-left: 0.25rem;
                
                &::placeholder{
                    padding-left: 0.25rem;
                    font-weight: 600;
                    font-size: 1rem;
                }
            }
        }
    }
`

const ContactHead = styled(motion.div)`
    flex: 0.6;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;

    @media only screen and (max-width: 845px) {
        flex: 1 !important;
    }

    h3{
        font-size: 4rem;
        font-family: var(--font2);
        color: white;
        position: relative;
        font-weight: 560;
    }
`

const ContactDiv = styled(motion.div)`
    display: flex;
    min-height: 100vh;
    padding: 8rem 0;
    width: 80%;
    margin:auto;
    
    .contactDiv{
        display: flex;
        gap: 4rem;
        min-height: 100vh;
        justify-content: space-around;
        width:100%;
        
        @media only screen and (max-width: 845px) {
            flex-direction: column-reverse;
            gap: 1rem !important;
            justify-content: flex-end !important;
        }
    }


`